import { memo } from 'react'
import { _x } from '@wordpress/i18n'

const FilterModal = memo(function FilterModal(props: {
  title: string
  children: React.ReactNode
  id?: string
}) {
  return (
    <div
      className="modal fade is-mobile-fullscreen filter-modal"
      id={props.id ?? 'filter-modal'}
      tabIndex={-1}
      data-bs-theme="dark"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{props.title}</h3>
            <button
              className="close btn-close-fa"
              type="button"
              data-bs-dismiss="modal"
              aria-label={_x(
                'Close Filters',
                'Filter Modal Close Button',
                'icf'
              )}
            />
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer">
            <button className="close btn" type="button" data-bs-dismiss="modal">
              <i className="icon fa-xmark" />
              {_x('Close Filters', 'Filter Modal Close Button', 'icf')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
})

export default FilterModal
